import React, { useState, useRef, useCallback, useMemo, useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import _ from 'lodash';
import { axiosPrivateInstance } from '../../axios';
import Modal from 'react-modal';
import { useTranslation } from 'react-i18next';

// Leaflet ikon ayarı (create-react-app için düzeltilmiş versiyon)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
  iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
  shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

const MapView = ({ geojsonData, mapType, selectedProject, selectedNamespace, conditions }) => {
  const { t, i18n } = useTranslation();
 
  const [centerPosition, setCenterPosition] = useState([41.0082, 28.9784]);
//  const [centerPosition, setCenterPosition] = useState([41.0082, 28.9784]);
  //const [centerPosition, setCenterPosition] = useState([geojsonData.features[0].geometry.coordinates[1], geojsonData.features[0].geometry.coordinates[0]]);
  const [zoomLevel] = useState(18);
  const [markers, setMarkers] = useState([]);
  const [isMounted, setIsMounted] = useState(false);
  const prevBoundsRef = useRef(null);
  const hasCenteredRef = useRef(false); // Track if initial centering was done
  const mapRef = useRef(null);
  const [width, setWidth] = useState(0);
   const [modalIsOpen, setModalIsOpen] = useState(false);
    const [imageUrl, setImageUrl] = useState(null);
    const [actualImageName, setActualImageName] = useState("");
    const [imageProcessingMessage, setImageProcessingMessage] = useState({
        content: "",
        status: "",
        visible: false
    });
        const [isSaveFileDisabled, setIsSaveFileDisabled] = useState(true);
        const [activePopup, setActivePopup] = useState(null);
        const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
  
        async function handleImage(imageName){
        //alert(imageName);
        setActualImageName(imageName);
        await axiosPrivateInstance.post("mergintransactions/checkforfile", JSON.stringify({
		filename: imageName,
		project_name: selectedProject
	})).then(async checkForFileRes => {
		if(checkForFileRes.status == 200 && checkForFileRes.data.exists){
		        setImageProcessingMessage({
				content: t("imageOpening"),
				status: "OK",
				visible: true
		    	})
		    	await axiosPrivateInstance.post('mergintransactions/serveimage', JSON.stringify({
				            project_name: selectedProject,
				            filename: imageName
				        }), {
				            responseType: 'blob'
				        }).then(serveImageRes => {
					    setImageProcessingMessage({
							content: "",
							status: "DONE",
							visible:false
    				    	    });
				            const imageBlob = serveImageRes.data;
				            const url = URL.createObjectURL(imageBlob);
				            setImageUrl(url);
				            setModalIsOpen(true);
				            console.log("Image URL status = ", serveImageRes.status);
				        }).catch(err => {
				            setImageProcessingMessage({
							content: "Error on serving image",
							status: "ERR",
							visible: true
       			    	            });
				            console.log(err);
				        })
		}
		else{
		    await axiosPrivateInstance.post('mergintransactions/downloadfile', JSON.stringify({
			    namespace:  selectedNamespace,
			    project_name: selectedProject,
			    file_path: imageName
			})).then(async downloadFileRes => {
				    setImageProcessingMessage({
						content: t("imageOpening"),
						status: "OK",
						visible: true
	     		       	    });
				    if(downloadFileRes.status == 200){
				        //modali aktif et, resmi ac
				        await axiosPrivateInstance.post('mergintransactions/serveimage', JSON.stringify({
				            project_name: selectedProject,
				            filename: imageName
				        }), {
				            responseType: 'blob'
				        }).then(async serveImageRes => {
						setImageProcessingMessage({
						content: "",
						status: "DONE",
						visible: false
					    });
				            const imageBlob = serveImageRes.data;
				            const url = URL.createObjectURL(imageBlob);
				                        const img = new Image();
            img.src = url;
            await new Promise((resolve) => {
                img.onload = resolve;
            });
            
            setImageDimensions({
                width: img.width,
                height: img.height
            });
				            
				            
				            setImageUrl(url);
				            setModalIsOpen(true);
				            console.log("Image URL status = ", serveImageRes.status);
				        }).catch(err => {
				           setImageProcessingMessage({
						content: err.response.data.error,
						status: "ERR",
						visible: true
					    });
				            console.log(err);
				        })
				    }
				}).catch(err => {
				setImageProcessingMessage({
					content: err.response.data.error,
					status: "ERR",
					visible: true
			    	})
				    console.log(err);
				});
		}
	 }).catch(err => {
	      console.log("error on checkfile");
	      console.log(err);
	 });
		/*
        await axiosPrivateInstance.post('mergintransactions/downloadfile', JSON.stringify({
				    namespace:  selectedNamespace,
				    project_name: selectedProject,
				    file_path: imageName
				})).then(res => {
				    console.log("response from image fownload request");
				    console.log(res);
				}).catch(err => {
				    console.log(err);
				});
				*/
    }


  useEffect(() => {
      console.log("Image dimensions");
      console.log(imageDimensions);
  }, [imageDimensions])



  // Bileşen mount/unmount takibi
  useEffect(() => {
    setIsMounted(true);
    return () => setIsMounted(false);
  }, []);
  
  
  useEffect(() => {
  

	if(mapRef.current && geojsonData.features && geojsonData.features.length > 0){
	//geojsonData yi EPSG:4326 ya cevir
	   try{
	    mapRef.current.setView([geojsonData.features[0].geometry.coordinates[1], geojsonData.features[0].geometry.coordinates[0]], 16);
	    }
	    catch(e){
	        console.log(e);
	        return;
	    }
	}
	
  }, [geojsonData, mapRef.current])
  
  
  /*
    useEffect(() => {
    if (markers.length > 0 && !hasCenteredRef.current) {
      const firstMarkerPosition = markers[0].position;
      setCenterPosition(firstMarkerPosition);
      hasCenteredRef.current = true; // Mark as centered
    }
  }, [markers]);
  */

  // Harita eventlerini yöneten bileşen
  const MapEventHandler = () => {
    const fetchData = useCallback(
      _.debounce(async (bounds) => {
        if (!isMounted) return;
        
        try {
          if (prevBoundsRef.current && bounds.equals(prevBoundsRef.current)) {
            return;
          }
          prevBoundsRef.current = bounds;
          /*
let path = `./../projects/${selectedProject}/${mapType}.gpkg`;
          const response = await axiosPrivateInstance.post('mergintransactions/setgpkgdataformap', {
            north: bounds.getNorth(),
            south: bounds.getSouth(),
            east: bounds.getEast(),
            west: bounds.getWest(),
            width: width && width,
            file_name: `${mapType}.gpkg`,
            project_name: selectedProject,
            conditions: (conditions && typeof conditions === 'object' && Object.keys(conditions).length) 
    ? JSON.stringify(conditions) 
    : null,
    path: path
          });

          if (!isMounted) return;

          const data = JSON.parse(response.data.response);
          if(data.features && data.features.length > 7000)
              return;
            //setCenterPosition([data.features[0].geometry.coordinates[1], data.features[0].geometry.coordinates[0]]);
          /*
          if(data && data.features && data.features.length > 0){
              console.log("data.features[0]");
              console.log(data.features[0]);
          }
          */
          
          let path = `./../projects/${selectedProject}/${mapType}.gpkg`;
      let response;
      let lastError;
      
      // 5 deneme yap
      for (let attempt = 0; attempt < 5; attempt++) {
        try {
          response = await axiosPrivateInstance.post('mergintransactions/setgpkgdataformap', {
            north: bounds.getNorth(),
            south: bounds.getSouth(),
            east: bounds.getEast(),
            west: bounds.getWest(),
            width: width && width,
            file_name: `${mapType}.gpkg`,
            project_name: selectedProject,
            conditions: (conditions && typeof conditions === 'object' && Object.keys(conditions).length) 
              ? JSON.stringify(conditions) 
              : null,
            path: path
          });

          // Başarılı olduğunda döngüden çık
          break;
          
        } catch (err) {
          lastError = err;
          if (attempt < 4) { // Son deneme değilse bekle
            await new Promise(resolve => setTimeout(resolve, 1000));
            console.log(`Deneme ${attempt + 1} başarısız, yeniden deniyorum...`);
          }
        }
      }

      // Hala response yoksa (tüm denemeler başarısız)
      if (!response) {
        throw lastError || new Error('Tüm denemeler başarısız oldu');
      }

      if (!isMounted) return;

      const data = JSON.parse(response.data.response);
      if (data.features && data.features.length > 7000) {
        return;
      }
          
          
         
          const newMarkers = data.features.map(feature => ({
            position: [feature.geometry.coordinates[1], feature.geometry.coordinates[0]],
            properties: feature.properties
          }));
          
          setMarkers(newMarkers);

        } catch (err) {
          if (isMounted) {
            console.error("Veri çekme hatası:", err);
          }
        }
      }, 500),
      [selectedProject, mapType, isMounted]
    );
    
    useEffect(() => {
        if(markers){
           console.log("markers:");
           console.log(markers);
        }
    }, [markers])
    
    useEffect(() => {
        console.log("width");
        console.log(width)
    }, [width])
    
    
    const calculateDistance = useCallback((map) => {
        if(!map) return;
                setWidth(map.distance(map.getBounds().getNorthWest(), map.getBounds().getNorthEast()) / 1000);
    });

    const map = useMapEvents({
      moveend() {
        fetchData(map.getBounds());
        calculateDistance(map);
      },
      load() {
        fetchData(map.getBounds());
      },
      zoomend(){
        fetchData(map.getBounds());
        calculateDistance(map);
      }
    });

    return null;
  };

  const getMarkerColor = (id) => {
    if (!id) return "black";
    if (id === "1" || id === "À installer" || id == "TAKILACAK") return "red";
    if (id === "2" || id === "Installé" || id == "TAKILDI") return "green";
    if (id === "3" || id === "Non installé" || id == "TAKILAMADI" || id == "TAKILMADI") return "blue";
    if (id === "4" || id === "Réglé" || id == "DÜZENLEME" || id == "DÜZENLENDİ") return "yellow";
    return "black";
  };
  
  const assignMarkerIcon = useMemo(() => {
    const iconCache = {};
    return (id, doorNumber) => {
      const cacheKey = `${id}_${doorNumber}`;
      
      if (!iconCache[cacheKey]) {
        const markerColor = getMarkerColor(id);
        iconCache[cacheKey] = L.divIcon({
          html: `
            <div style="
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              width: 24px;
              height: 24px;
            ">
              <div style="
                background-color: ${markerColor};
                width: 10px;
                height: 10px;
                border-radius: 50%;
                margin-bottom: 2px;
              "></div>
              <div style="
                color: ${markerColor};
                font-weight: bold;
                font-size: 9px;
                text-align: center;
                line-height: 1;
                text-shadow: 0 0 2px white;
              ">${doorNumber || ''}</div>
            </div>
          `,
          className: 'custom-marker-icon',
          iconSize: [24, 24],
          iconAnchor: [12, 24]
        });
      }
      return iconCache[cacheKey];
    };
  }, []);


    const parseMountageState = (n) => {
        if(n === "1"){
            return t('willBeMounted');
        }
        else if(n === "2" || n === "4"){
            return t('mounted');
        }
        else if(n === "3") {
            return t('notMounted');
        }
    };
    
        async function handleDeleteImage(actualImageName){
        await axiosPrivateInstance.post("mergintransactions/deletefile", JSON.stringify({
            project_name: selectedProject,
            file_name: actualImageName
        })).then(res => {
             
             if(res.status == 200){
             setImageProcessingMessage({
        	content: t('imageClosed'),
        	status: "OK",
        	visible: true
    	})

             }
             else{
              setIsSaveFileDisabled(false);     
             }
        }).catch(err => {
        setIsSaveFileDisabled(false);
        setImageProcessingMessage({
        	content: err.response.data.error,
        	status: "ERR",
        	visible: true
    	})
            console.log(err);
        })
        setModalIsOpen(false);
    }
    
      useEffect(() => {
    let timer;
    
    if (imageProcessingMessage.visible) {
      // 2 saniye sonra visible'ı false yap
      timer = setTimeout(() => {
        setImageProcessingMessage(prev => ({
          ...prev,
          visible: false
        }));
      }, 2000);
    }

    // Cleanup fonksiyonu - component unmount olursa timer'ı temizle
    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [imageProcessingMessage.visible]);
    
    
  return (
    <div style={{ height: '100vh', width: '100%', position: 'relative' }}>
        {
        imageProcessingMessage.visible && imageProcessingMessage.content && imageProcessingMessage.content.length > 0 ? <div className={imageProcessingMessage.status == "OK" ? "alert alert-info my-1" : "alert alert-danger my-1"} role="alert" style={{ zIndex: 1003, overflow: "hidden", maxWidth: '50%', margin: 'auto' }}>
  {    imageProcessingMessage.content}
</div> : ""
    }
      <MapContainer 
        key={`map-${selectedProject}-${mapType}`} // Yenileme için unique key
        center={centerPosition} 
        zoom={zoomLevel} 
        style={{ height: '100%', width: '100%' }}
        ref = {mapRef}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        />
        
        <MapEventHandler />
        
        {markers.map((marker, index) => {
          const montajDurum = marker.properties?.MONTAJDURUM ?? 
                             marker.properties?.ÉTAT ?? 
                             marker.properties?.MONTAJDURU;
          const kapıNo = marker.properties?.DISKAPINO1 ?? marker.properties?.KAPINO;
          
          return (
            <Marker 
              key={`marker-${index}-${montajDurum}-${kapıNo}`}
              position={marker.position}
              icon={assignMarkerIcon(montajDurum, kapıNo)}
            >
              <Popup
              className="bootstrap-popup"
	      autoPan={false}
              closeOnClick={true}
              autoPanPaddingTopLeft={[0,0]}
              autoPanPaddingBottomRight={[0,0]}  
              >
                <div style={{ maxWidth: '250px' }}>
                  {Object.entries(marker.properties || {}).map(([key, value]) => (
                    <div key={key} style={{ marginBottom: '4px' }}>
                      <strong>{key}:</strong> {
                          value?.toString().match(/MONTAJDURUM|MONTAJDURU|ÉTAT/i) ?
                          (
                              parseMountageState(value)
                          ) : value?.toString().match(/\.(jpg|png)/i) ? (
                          <button 
		            className="btn btn-link p-0 text-primary" 
		            onClick={() => handleImage(value)}
		          >
		            {t('showImage')}
		          </button>
                          ) : (
                              value
                          )
                      }
                    </div>
                  ))}
                </div>
              </Popup>
            </Marker>
          );
        })}
      </MapContainer>
<Modal
  isOpen={modalIsOpen}
  onRequestClose={() => {}}
  shouldCloseOnOverlayClick={false}
  shouldCloseOnEsc={false}
  contentLabel="Image Viewer"
  style={{
    overlay: {
      zIndex: 1000,
      backgroundColor: 'rgba(0, 0, 0, 0.75)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },
    content: {
      position: 'relative',
      inset: 'auto',
      padding: '0',
      margin: '0',
      border: 'none',
      background: 'none',
      overflow: 'visible',
      width: 'auto',
      height: 'auto'
    }
  }}
>
  {/* Resim Container */}
  <div style={{
    position: 'relative',
    display: 'inline-block'
  }}>
    {!isSaveFileDisabled && (
      <h6 className="text-success" style={{
        position: 'absolute',
        top: '-30px',
        left: '0',
        zIndex: 1002
      }}>
        "Please click to green button"
      </h6>
    )}
    
    {imageUrl && (
      <img 
        src={imageUrl} 
        alt="Görüntülenen Dosya"
        style={{
          display: 'block',
          width: `${imageDimensions.width}px`,
          height: `${imageDimensions.height}px`,
          maxWidth: '95vw',
          maxHeight: '95vh',
          objectFit: 'contain'
        }}
      />
    )}

    {/* Buton Container - Sabit Sağ Üst Köşe */}
    <div style={{
      position: 'absolute',
      top: '10px',
      right: '10px',
      zIndex: 1003
    }}>
      <button 
        onClick={() => handleDeleteImage(actualImageName)}
        style={{
          padding: '10px 15px',
          backgroundColor: '#990000',
          color: 'white',
          border: 'none',
          borderRadius: '50%',
          cursor: 'pointer',
          fontSize: '16px',
          fontWeight: 'bold',
          width: '40px',
          height: '40px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: '0 2px 5px rgba(0,0,0,0.3)'
        }}
      >
        X
      </button>
    </div>
  </div>
</Modal>
    </div>
  );
};

export default MapView;
